import {Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {ErrorState, SentinelLoading} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {ExamResultsTaggingEnum} from 'main/analytics/gaTagsEnum';
import {Filter} from 'presentation/components/Filter';
import {useHostName} from 'presentation/hooks';

import {ExamsContainer} from './styles';
import {useExamRequests} from 'presentation/modules/examResults/hooks/useExamRequests';
import {ExamsRequestsFlowEnum} from 'presentation/modules/examResults/hooks/useExamRequests/types';
import {LoadingSkeleton} from '../../components/LoadingSkeleton';
import {NdiExamHistoryAlert} from '../../components/NdiExamHistoryAlert';
import {FilterDrawer} from '../../components/FilterDrawer';
import {ExamsListEmptyState} from '../../components/ExamsListEmptyState';
import {ExamCardsGrid} from '../../components/ExamsCardsGrid';
import {ExamDrawer} from '../../components/ExamDrawer';

const {lastYear, resultError} = translations['pt-br'].privateFlow.examResults;
const {resultFound, resultsFound} = translations['pt-br'].commons;

export function ReleasedExamResults() {
	const {isGndiSaoPaulo, isNotredameSaude} = useHostName();

	const {
		loadingItemsList,
		itemsListHasError,
		refresh,
		itemsListIsEmpty,
		items,
		onSentinelVisible,
		isLoadingMore,
		totalItems,
		handleClearFilters,
		hideFilterDrawer,
	} = useExamRequests(ExamsRequestsFlowEnum.RELEASED);

	if (loadingItemsList && !isLoadingMore) {
		return (
			<ExamsContainer>
				<LoadingSkeleton />
			</ExamsContainer>
		);
	}
	if (itemsListHasError) {
		return (
			<ErrorState
				title={resultError.title}
				description={resultError.description}
				handleRefresh={refresh}
				containerDataTagId={ExamResultsTaggingEnum.VISUALIZOU_ERROR_STATE_LIBERADOS}
			/>
		);
	}

	return (
		<ExamsContainer>
			<Stack gap={2}>
				{isGndiSaoPaulo || isNotredameSaude ? <NdiExamHistoryAlert /> : null}
				<Stack direction={'row'} justifyContent="space-between" alignItems="center">
					<Filter.MonthYear
						customButtonLabel={lastYear}
						minDate={new Date('2001')}
						maxDate={new Date()}
						sx={{p: 0}}
						data-tag-id={ExamResultsTaggingEnum.CLICK_FILTRAR_DATA_RESULTADO_DE_EXAMES}
					/>

					{hideFilterDrawer ? null : <FilterDrawer />}
				</Stack>
				{itemsListIsEmpty ? (
					<ExamsListEmptyState clearFilter={handleClearFilters} />
				) : (
					<Fragment>
						<Typography color={'text.secondary'} textTransform={'lowercase'}>
							<b>{totalItems}</b> {totalItems === 1 ? resultFound : resultsFound}
						</Typography>

						<ExamCardsGrid list={items} />
						<ExamDrawer />

						<SentinelLoading
							onVisible={onSentinelVisible}
							isLoading={loadingItemsList}
						/>
					</Fragment>
				)}
			</Stack>
		</ExamsContainer>
	);
}
